// Name or label-name substring match, case insensitive
const isContentItemMatch = ({
  contentItem,
  searchText,
  labelLookup,
}: {
  contentItem: Pick<ContentIndexTypes.ContentItem, 'name' | 'labelIds'>;
  searchText: string;
  labelLookup: { [labelId: string]: { name: string } | undefined };
}) => {
  if (searchText === '') {
    return true;
  }

  const lowerSearchText = searchText.toLowerCase();
  if (contentItem.name.toLowerCase().includes(lowerSearchText)) {
    return true;
  }

  return contentItem.labelIds.some((lid) => {
    const label = labelLookup[lid];
    if (!label) {
      return false;
    }

    return label.name.toLowerCase().includes(lowerSearchText);
  });
};

export default isContentItemMatch;
